import localLandingData from "@/data/local-landing-pages.json";
import type { SiteLocale } from "@/lib/i18n/config";

type LocalLandingPage = { locale: SiteLocale; slug: string; directory: string[]; blogCategoryId: string; blogPosts: string[] };

const pages = localLandingData.pages as Record<string, LocalLandingPage>;

/** City landing pages exist in one locale only, at their historical single-segment URL. */
export function resolveLocalLandingCity(segment: string, locale: string): string | null {
  return Object.entries(pages).find(([, page]) => page.locale === locale && page.slug === segment)?.[0] ?? null;
}

export function getLocalLandingPage(city: string): LocalLandingPage | undefined {
  return pages[city];
}

export function listLocalLandingCities(): string[] {
  return Object.keys(pages);
}
